var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 0H0.5V14H21.4998V0Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3124 0H9.6874V5.68741H0.5V8.31238H9.6874V13.9998H12.3124V8.31238H21.4998V5.68741H12.3124V0Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6514 9.43457L21.5 12.1283V9.43457H16.6514Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2827 9.43457L21.5 13.9997V12.7088L15.6064 9.43457H13.2827Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3112 13.9994L13.2827 10.6499V13.9994H19.3112Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2827 9.43457L21.5 13.9997V12.7088L15.6064 9.43457H13.2827Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2827 9.43457L21.5 13.9997V12.7088L15.6064 9.43457H13.2827Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20584 9.43457L0.500488 11.4931V9.43457H4.20584Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71769 10.0151V13.9998H1.5459L8.71769 10.0151Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39359 9.43457L0.5 12.7088V13.9997L8.71731 9.43457H6.39359Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34861 4.56481L0.5 1.87109V4.56481H5.34861Z",
    fill: "#0052B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71731 4.56515L0.5 0V1.29091L6.39359 4.56515H8.71731Z",
    fill: "#0052B4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68896 0L8.71746 3.34946V0H2.68896Z",
    fill: "#0052B4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71731 4.56515L0.5 0V1.29091L6.39359 4.56515H8.71731Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71731 4.56515L0.5 0V1.29091L6.39359 4.56515H8.71731Z",
    fill: "#D80027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 4.56539L21.5003 2.50684V4.56539H17.7949Z",
    fill: "#0052B4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2827 3.98467V0H20.4545L13.2827 3.98467Z",
    fill: "#0052B4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6064 4.56515L21.5 1.29091V0L13.2827 4.56515H15.6064Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.393e0cc6ef4b673c25ffbaf41cff1c1d.svg";
export { ForwardRef as ReactComponent };